import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module'
import { AuthGuard } from '../auth-guard.service';
import { HomeComponent } from './home.component';
import { AccountDashboardComponent } from './accountdashboard.component';
import { MyBusinessAdvantageNewComponent } from './mybusinessadvantage.new.component';
import { MyDriversClubNewComponent } from './mydriversclub.new.component';
import { MyFleetSolutionsNewComponent } from './myfleetsolutions.new.component';
import { AccountGuard } from '../account-guard.service';
import { SurveyComponent } from './survey.component';
import { HomeService } from './home.service';
import { RelatedDriverNewsComponent } from './relateddrivernews.component';

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild([
          { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
          { path: 'accountdashboard', component: AccountDashboardComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'my-business-advantage', component: MyBusinessAdvantageNewComponent, canActivate: [AuthGuard] },
          { path: 'my-drivers-club', component: MyDriversClubNewComponent, canActivate: [AuthGuard] },
          { path: 'my-fleet-solutions', component: MyFleetSolutionsNewComponent, canActivate: [AuthGuard] },
          { path: 'survey', component: SurveyComponent, canActivate: [AuthGuard] },
        ])
    ],
    exports: [
        
    ],
    declarations: [
      HomeComponent,
      AccountDashboardComponent,
      MyBusinessAdvantageNewComponent,
      MyDriversClubNewComponent,
      MyFleetSolutionsNewComponent,
      SurveyComponent      
    ],
    providers: [        
      HomeService
    ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts